import { render } from "./mobile-portal.vue?vue&type=template&id=5bf0a6d2&scoped=true"
import script from "./mobile-portal.vue?vue&type=script&lang=js"
export * from "./mobile-portal.vue?vue&type=script&lang=js"

import "./mobile-portal.vue?vue&type=style&index=0&id=5bf0a6d2&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf0a6d2"]])

export default __exports__